import _ from 'lodash-es';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, ButtonGroup } from 'reactstrap';
import { sendCommand } from '../../../actions/atorch';
import { CommandSet } from '../../../service/atorch-packet';
// eslint-disable-next-line react/display-name
export const Toolbar = React.memo(({ type }) => {
    const dispatch = useDispatch();
    const btnFn = {
        'Setup': CommandSet.setup.bind(null, type),
        '\u2795': CommandSet.setPlus.bind(null, type),
        '\u2796': CommandSet.setMinus.bind(null, type),
        'Enter': CommandSet.enter.bind(null, type),
        'Reset All': CommandSet.resetAll.bind(null, type),
    };
    const makeCommand = (cb) => () => {
        dispatch(sendCommand(cb()));
    };
    return (React.createElement(ButtonGroup, null, _.map(btnFn, (builder, text) => (React.createElement(Button, { key: text, outline: true, onClick: makeCommand(builder) }, text)))));
});
